import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute, AdminRoute } from './components/layout/ProtectedRoute';

// Páginas públicas
import Login      from './pages/Login';
import TrocaSenha from './pages/TrocaSenha';

// Páginas comuns
import Catalogo from './pages/Catalogo';
import Detalhe  from './pages/Detalhe';

// Páginas admin
import Dashboard   from './pages/admin/Dashboard';
import Produtos    from './pages/admin/Produtos';
import ProdutoForm from './pages/admin/ProdutoForm';
import Usuarios    from './pages/admin/Usuarios';
import Lojas       from './pages/admin/Lojas';
import Categorias  from './pages/admin/Categorias';

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <Routes>
        {/* Públicas */}
        <Route path="/login"       element={<Login />} />
        <Route path="/trocar-senha" element={<TrocaSenha />} />

        {/* Redirect raiz */}
        <Route path="/" element={<Navigate to="/catalogo" replace />} />

        {/* Protegidas — todos os usuários autenticados */}
        <Route path="/catalogo"    element={<ProtectedRoute><Catalogo /></ProtectedRoute>} />
        <Route path="/produto/:id" element={<ProtectedRoute><Detalhe /></ProtectedRoute>} />

        {/* Admin only */}
        <Route path="/admin"                   element={<AdminRoute><Dashboard /></AdminRoute>} />
        <Route path="/admin/produtos"          element={<AdminRoute><Produtos /></AdminRoute>} />
        <Route path="/admin/produtos/novo"     element={<AdminRoute><ProdutoForm /></AdminRoute>} />
        <Route path="/admin/produtos/:id"      element={<AdminRoute><ProdutoForm /></AdminRoute>} />
        <Route path="/admin/usuarios"          element={<AdminRoute><Usuarios /></AdminRoute>} />
        <Route path="/admin/lojas"             element={<AdminRoute><Lojas /></AdminRoute>} />
        <Route path="/admin/categorias"        element={<AdminRoute><Categorias /></AdminRoute>} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/catalogo" replace />} />
      </Routes>
    </AuthProvider>
  </BrowserRouter>
);

export default App;
